import { render, staticRenderFns } from "./ImageBox.vue?vue&type=template&id=e4ebdaf4&"
import script from "./ImageBox.vue?vue&type=script&lang=js&"
export * from "./ImageBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\invoicingfullversion2\\invoicing_app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4ebdaf4')) {
      api.createRecord('e4ebdaf4', component.options)
    } else {
      api.reload('e4ebdaf4', component.options)
    }
    module.hot.accept("./ImageBox.vue?vue&type=template&id=e4ebdaf4&", function () {
      api.rerender('e4ebdaf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/components/ImageBox.vue"
export default component.exports